import { BrowserRouter, Routes, Route } from "react-router-dom";
import AnalyticsTracker from "../components/common/AnalyticsTracker";
import Home from "../pages/Home";
import { AuthProvider } from "../components/context/AuthContext";
import AboutUs from "../components/common/AboutUs";
import CartPage from "../components/common/cartpage/CartPage";
import MainLayout from "../layout/MainLayout";
import PaymentPage from "../components/common/paymentpage/PaymentPage";
import OrderConfirmation from "../components/common/OderConfirmation";
import ShopPage from "../components/common/ShopPage";
import ProductPage from "../components/common/productpage/ProductPage";
import Mentop from "../components/common/mens/mendropdown/Mentop";
import CategoryMentop from "../components/common/mens/mendropdown/CategoryMenTop";

import LoginPage from "../pages/auth/LoginPage";
import SignupPage from "../pages/auth/SignupPage";
import ForgotPasswordPage from "../pages/auth/ForgotPasswordPage";
import ResetPasswordPage from "../pages/auth/ResetPasswordPage";
import ProfilePage from "../pages/auth/ProfilePage";
import CartDrawer from "../components/common/cartpage/CartDrawer";
import PaymentFailure from "../components/common/paymentpage/PaymentFailure";
import PaymentSuccess from "../components/common/paymentpage/PaymentSuccess";
import CustomerDashboard from "../components/common/customer/CustomerDashboard";
import UserProfile from "../components/common/customer/UserProfile";
import OrdersPage from "../components/common/customer/CustomerOrder";
import KitBuilder from "../pages/KitBuilder";
import PrivacyPolicy from "../components/common/PrivacyPolicy";
import DeliveryReturnPolicy from "../components/common/DeliveryReturnPolicy";
import TermsAndConditions from "../components/common/TermsAndCondition";
import FrequentlyAskedQuestions from "../components/common/FrequentlyAskedQuestions";
import Catalogue from "../components/common/Catalogue";
import ContactUs from "../components/common/ContactUs";
import FabricGuide from "../components/common/FabricGuide";
import BlogDetail from "../components/common/blog/Blog";
import BlogPage from "../components/common/blog/AllBlog";
import NewArrivals from "../components/common/newarrival/NewArrivals";
import SizeChart from "../components/common/SizeChart";

export default function AppRoutes({
  openCart,
  cartItems,
  handleRemoveItem,
  handleIncreaseQuantity,
  handleDecreaseQuantity,
}) {
  return (
    <BrowserRouter>
    <AnalyticsTracker />
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/auth/forgotpassword" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/profile" element={<ProfilePage />} />

          <Route
            path="/"
            element={
              <MainLayout openCart={openCart}>
                <Home />
              </MainLayout>
            }
          />
          <Route
            path="/about"
            element={
              <MainLayout openCart={openCart}>
                <AboutUs />
              </MainLayout>
            }
          />
          <Route
            path="/privacypolicy"
            element={
              <MainLayout openCart={openCart}>
                <PrivacyPolicy />
              </MainLayout>
            }
          />
          <Route
            path="/deliveryreturnpolicy"
            element={
              <MainLayout openCart={openCart}>
                <DeliveryReturnPolicy />
              </MainLayout>
            }
          />
          <Route
            path="/termsandconditions"
            element={
              <MainLayout openCart={openCart}>
                <TermsAndConditions />
              </MainLayout>
            }
          />
          <Route
            path="/frequently-asked-questions"
            element={
              <MainLayout openCart={openCart}>
                <FrequentlyAskedQuestions />
              </MainLayout>
            }
          />
          <Route
            path="/catalogue"
            element={
              <MainLayout openCart={openCart}>
                <Catalogue />
              </MainLayout>
            }
          />
          <Route
            path="/contact"
            element={
              <MainLayout openCart={openCart}>
                <ContactUs />
              </MainLayout>
            }
          />
          <Route
            path="/fabricguide"
            element={
              <MainLayout openCart={openCart}>
                <FabricGuide />
              </MainLayout>
            }
          />
          <Route
            path="/cart"
            element={
              <MainLayout openCart={openCart}>
                <CartPage
                  cartItems={cartItems}
                  handleRemoveItem={handleRemoveItem}
                  handleIncreaseQuantity={handleIncreaseQuantity}
                  handleDecreaseQuantity={handleDecreaseQuantity}
                />
              </MainLayout>
            }
          />
          <Route
            path="/addcart"
            element={
              <MainLayout openCart={openCart}>
                <CartDrawer
                  cartItems={cartItems}
                  handleRemoveItem={handleRemoveItem}
                  handleIncreaseQuantity={handleIncreaseQuantity}
                  handleDecreaseQuantity={handleDecreaseQuantity}
                />
              </MainLayout>
            }
          />
          <Route
            path="/payment"
            element={
              <MainLayout openCart={openCart}>
                <PaymentPage />
              </MainLayout>
            }
          />
          <Route
            path="/orderplaced"
            element={
              <MainLayout openCart={openCart}>
                <OrderConfirmation />
              </MainLayout>
            }
          />
          <Route
            path="/shop"
            element={
              <MainLayout openCart={openCart}>
                <ShopPage />
              </MainLayout>
            }
          />
          <Route
            path="/:slug"
            element={
              <MainLayout openCart={openCart}>
                <ProductPage />
              </MainLayout>
            }
          />
          <Route
            path="/post/:slug"
            element={
              <MainLayout openCart={openCart}>
                <Mentop />
              </MainLayout>
            }
          />
          <Route
            path="/:slug/:slug"
            element={
              <MainLayout openCart={openCart}>
                <Mentop />
              </MainLayout>
            }
          />
          <Route
            path="/category/:slug/products"
            element={
              <MainLayout openCart={openCart}>
                <CategoryMentop />
              </MainLayout>
            }
          />


          {/*PAYMENT PATH PAYU */}
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/failure" element={<PaymentFailure />} />

          {/*Customer  */}
          <Route
            path="/userdashboard"
            element={
              <MainLayout openCart={openCart}>
                {" "}
                <CustomerDashboard />{" "}
              </MainLayout>
            }
          />
          <Route
            path="/userprofile"
            element={
              <MainLayout openCart={openCart}>
                <UserProfile />
              </MainLayout>
            }
          />
          <Route
            path="/userorder"
            element={
              <MainLayout openCart={openCart}>
                <OrdersPage />
              </MainLayout>
            }
          />

          {/* kit builder */}

          <Route
            path="/design-your-own"
            element={
              <MainLayout>
                <KitBuilder />
              </MainLayout>
            }
          />
          <Route
            path="/blogs/:slug"
            element={
              <MainLayout openCart={openCart}>
                <BlogDetail />
              </MainLayout>
            }
          />
          <Route
            path="/blogs"
            element={
              <MainLayout openCart={openCart}>
                <BlogPage />
              </MainLayout>
            }
          />
          {/* New Arrival */}
          <Route
            path="/newarrival"
            element={
              <MainLayout openCart={openCart}>
                <NewArrivals />
              </MainLayout>
            }
          />
          {/* size chart */}
          <Route
            path="/sizechart"
            element={
              <MainLayout openCart={openCart}>
                <SizeChart />
              </MainLayout>
            }
          />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
